import moment from 'moment';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCertificadosAction,
  setCertificadosPropsAction,
  setLoadingDetallePolizaAction,
  setPlanSeleccionadoAction,
  setShowFormAddCertificadoAction,
  setStateDetallePolizaAction,
} from 'redux/actions/detallePoliza.action';
import { PRODUCTOS } from 'utils/constants';

const useDetallePoliza = () => {
  const state = useSelector((state) => state.detallePolizaReducer);
  const dispatch = useDispatch();

  const setStateDetallePoliza = useCallback(
    (payload) => {
      payload.poliza.polItems = payload?.poliza?.polItems?.map((item) => {
        if (payload?.poliza?.polDescripcionRamo === PRODUCTOS.TRAVELBTA) {
          item.valorTotal = item.valorTotal?.find(
            (valor) => valor?.monedaNombre === 'DOLARES',
          );
          const moneda = item.valorTotal.monedaSimbolo;
          const { impuestosTotal, primaNeta, primaTotal } = item.valorTotal;
          item.valorTotal.impuestosTotal = `${moneda} ${impuestosTotal}`;
          item.valorTotal.primaNeta = `${moneda} ${primaNeta}`;
          item.valorTotal.primaTotal = `${moneda} ${primaTotal}`;
        }
        return item;
      });

      dispatch(setStateDetallePolizaAction(payload));
    },
    [dispatch],
  );

  const setPlanSeleccionado = useCallback(
    (payload) => {
      dispatch(setPlanSeleccionadoAction(payload));
    },
    [dispatch],
  );

  const setShowForm = (payload) => {
    dispatch(setShowFormAddCertificadoAction(payload));
  };

  const setLoading = (payload) => {
    dispatch(setLoadingDetallePolizaAction(payload));
  };

  const setCertificadosProps = (payload) => {
    if (
      'certPaises' in payload &&
      'genero' in payload &&
      'parentescos' in payload &&
      'fechaNacimientoMinima' in payload &&
      'fechaNacimientoMaxima' in payload &&
      'edadMinima' in payload &&
      'edadMaxima' in payload &&
      'numeroBeneficiariosMaximos' in payload &&
      'numeroBeneficiariosMinimos' in payload &&
      'diasMax' in payload
    ) {
      const data = {
        plantilla: payload.plantilla,
        sources: {
          paises: payload.certPaises?.map((item) => ({
            label: item.label,
            value: item,
          })),
          generos: payload.genero,
          parentescos: payload.parentescos,
        },
        validaciones: {
          fechaNacimiento: {
            minima: payload?.fechaNacimientoMinima?.trim(),
            maxima: payload?.fechaNacimientoMaxima?.trim(),
          },
          edad: {
            minima: payload?.edadMinima,
            maxima: payload?.edadMaxima,
          },
          beneficiarios: {
            maximo: payload.numeroBeneficiariosMaximos,
            minimo: payload.numeroBeneficiariosMinimos,
          },
          diasMaximos: payload.diasMax,
        },
      };

      dispatch(setCertificadosPropsAction(data));
    }

    const certificados = payload.listaCertificados.map((item) => {
      return {
        ...item,
        canDelete: moment(item?.iniVigencia, 'DD-MM-yyyy').isAfter(
          moment(new Date()),
        ),
      };
    });
    dispatch(setCertificadosAction(certificados));
  };

  return {
    setStateDetallePoliza,
    poliza: state?.poliza,
    diccionarios: state?.diccionarios,
    planSeleccionado: state?.planSeleccionado,
    setPlanSeleccionado,
    setShowForm,
    showForm: state?.showFormAddCertificado,
    setLoading,
    loading: state?.loadingDetallePoliza,
    setCertificadosProps,
    certificadosProps: state?.certificadosProps,
    certificados: state?.certificados,
  };
};

export default useDetallePoliza;
